import { Injectable} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
@Injectable()

@AutoUnsubscribe()
export class InformationBoxSummaryService {
    
    ordenSeleccionada: object;

    gestionOr: FormGroup;
    public deshabiliarInfo;
    public updateOT = new BehaviorSubject<any>({});
    
    constructor() {}

    setdataOR(value) {
        this.ordenSeleccionada = value;
        this.updateOT.next(value);
    }

    observerUpdateOT() {
        return this.updateOT.asObservable();
    }
     
    set ocultarInfo(value) {
        this.deshabiliarInfo = value;
    }

    get ocultarInfo() {
        return this.deshabiliarInfo;
    }

}
